import { QueryParams, FilterQueryParams } from '@/types'

export const getFlattenParams = (params: QueryParams | FilterQueryParams) => {
  const buildQueryString = (obj: any, prefix = ''): string => {
    return Object.entries(obj)
      .map(([key, value]) => {
        const fullKey = prefix ? `${prefix}.${key}` : key

        if (value === undefined) return ''

        if (typeof value === 'object' && value !== null) {
          if (Array.isArray(value)) {
            return `${fullKey}=${value.join(',')}`
          } else if (key === 'price' || key === 'estimate') {
            return Object.entries(value)
              .map(([op, val]) => `${fullKey}=${op}:${val}`)
              .join('&')
          } else {
            return buildQueryString(value, fullKey)
          }
        }

        return `${fullKey}=${value}`
      })
      .filter(Boolean)
      .join('&')
  }

  let queryString = ''

  if ('filter' in params && params.filter) {
    queryString += buildQueryString({ filter: params.filter })
  }

  // 다른 파라미터 추가
  if ('sortBy' in params && params.sortBy) {
    queryString += queryString ? '&' : ''
    queryString += `sortBy=${Array.isArray(params.sortBy) ? params.sortBy.join(',') : params.sortBy}`
  }

  if ('search' in params && params.search) {
    queryString += queryString ? '&' : ''
    queryString += `search=${params.search}`
  }

  if ('page' in params && params.page) {
    queryString += queryString ? '&' : ''
    queryString += `page=${params.page}`
  }

  return queryString
}
